/**
 ******************************************************************************
 *** CAROUSEL COMPONENT ***
 ******************************************************************************
 */

import Flickity from 'flickity';

// eslint-disable-next-line no-unused-vars
const carousel = new Flickity('.c-carousel', {
  prevNextButtons: false,
  pageDots: false,
  cellAlign: 'center',
  freeScroll: true,
  wrapAround: true
});
